/* AllPharma Premium Theme JS */
(function () {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* Sticky header shadow */
  const headerWrap = $('.header-wrap');
  const onScroll = () => headerWrap && headerWrap.classList.toggle('is-scrolled', window.scrollY > 8);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Mobile nav */
  const mobileNav = $('#MobileNav');
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => { mobileNav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => { mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; }));

  /* Search overlay */
  const search = $('#SearchOverlay');
  $$('[data-search-open]').forEach((b) => b.addEventListener('click', () => { search.classList.add('is-open'); setTimeout(() => $('input', search).focus(), 50); }));
  if (search) search.addEventListener('click', (e) => { if (e.target === search || e.target.closest('[data-search-close]')) search.classList.remove('is-open'); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { search && search.classList.remove('is-open'); closeCart(); } });

  /* Reveal on scroll */
  const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.12 });
  $$('[data-reveal]').forEach((el) => io.observe(el));

  /* Toast */
  let toastTimer;
  window.toast = (msg) => {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-on'), 2600);
  };

  /* Cart drawer */
  const drawer = $('#CartDrawer');
  const overlay = $('#DrawerOverlay');
  function openCart() { if (!drawer) return; drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeCart() { if (!drawer) return; drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
  window.openCart = openCart;
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  document.addEventListener('click', (e) => { if (e.target.closest('[data-cart-close]') || e.target === overlay) closeCart(); });

  async function refreshCart(open) {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=cart-drawer,cart-icon-bubble`);
    const data = await res.json();
    if (data['cart-drawer'] && drawer) {
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const inner = html.querySelector('#CartDrawer');
      if (inner) drawer.innerHTML = inner.innerHTML;
    }
    if (data['cart-icon-bubble']) {
      const html = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
      const bubble = html.querySelector('.cart-count');
      $$('.cart-count').forEach((c) => { if (bubble) { c.textContent = bubble.textContent; c.dataset.count = bubble.dataset.count; } });
    }
    if (open) openCart();
  }
  window.refreshCart = refreshCart;

  /* Add to cart (any form with data-ajax-cart) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Ekleniyor…'; }
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!res.ok) { const err = await res.json(); throw new Error(err.description || 'Sepete eklenemedi'); }
      await refreshCart(true);
    } catch (err) { window.toast(err.message); }
    finally { if (btn) { btn.disabled = false; btn.innerHTML = label; } }
  });

  /* Quantity buttons + line changes */
  document.addEventListener('click', async (e) => {
    const qb = e.target.closest('[data-qty]');
    if (qb) {
      const input = qb.parentElement.querySelector('input');
      const v = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) + (qb.dataset.qty === 'plus' ? 1 : -1));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); await changeLine(rm.dataset.lineRemove, 0); }
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('input[data-line-qty]');
    if (input) await changeLine(input.dataset.lineQty, parseInt(input.value, 10) || 0);
  });
  async function changeLine(key, quantity) {
    await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    if ($('#MainCart')) { window.location.reload(); } else { await refreshCart(false); }
  }

  /* Product gallery */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    const main = $('#ProductMainImage');
    if (main) { main.src = t.dataset.thumb; main.srcset = ''; }
    $$('[data-thumb]').forEach((x) => x.classList.remove('is-active'));
    t.classList.add('is-active');
  });

  /* Variant selector */
  const variantForm = $('form[data-product-form]');
  if (variantForm) {
    const json = $('[data-variants-json]');
    const variants = json ? JSON.parse(json.textContent) : [];
    const selects = $$('select[data-option-index]', variantForm);
    const update = () => {
      const opts = selects.map((s) => s.value);
      const v = variants.find((x) => opts.every((o, i) => x.options[i] === o));
      const idInput = $('input[name=id]', variantForm);
      const btn = $('[type=submit]', variantForm);
      const price = $('#ProductPrice');
      if (v) {
        idInput.value = v.id;
        if (price) price.innerHTML = window.formatMoney ? window.formatMoney(v.price) : price.innerHTML;
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.dataset.add : btn.dataset.sold;
        if (v.featured_image) { const main = $('#ProductMainImage'); if (main) { main.src = v.featured_image.src; main.srcset = ''; } }
      }
    };
    selects.forEach((s) => s.addEventListener('change', update));
  }

  /* Multi add (bundle / quiz) */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-add-multi]');
    if (!b) return;
    e.preventDefault();
    let items = [];
    try { items = JSON.parse(b.dataset.addMulti); } catch (err) { return; }
    if (!items.length) return;
    const label = b.innerHTML; b.disabled = true; b.innerHTML = 'Ekleniyor…';
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!res.ok) { const err = await res.json(); throw new Error(err.description || 'Sepete eklenemedi'); }
      await refreshCart(true);
    } catch (err) { window.toast(err.message); }
    finally { b.disabled = false; b.innerHTML = label; }
  });

  /* Hero product slider */
  $$('[data-hero-slider]').forEach((root) => {
    const imgs = $$('.hs', root); if (!imgs.length) return;
    const iv = parseInt(root.dataset.interval, 10) || 5000; let i = 0, t;
    const set = (n) => {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach((im, k) => im.classList.toggle('on', k === i));
      const d = imgs[i].dataset;
      const q = (s) => root.querySelector(s);
      q('[data-hs-idx]').textContent = String(i + 1).padStart(2, '0');
      q('[data-hs-name]').textContent = d.name; q('[data-hs-link]').href = d.url;
      q('[data-hs-meta]').textContent = d.meta; q('[data-hs-price]').textContent = d.price;
      q('[data-hs-variant]').value = d.variant;
      const btn = q('.stage__card [type=submit]'); btn.disabled = d.available !== 'true';
      const bar = q('[data-hs-bar]'); bar.style.transition = 'none'; bar.style.width = '0';
      requestAnimationFrame(() => { bar.style.transition = `width ${iv - 300}ms linear`; bar.style.width = '100%'; });
      clearInterval(t); t = setInterval(() => set(i + 1), iv);
    };
    root.addEventListener('click', (e) => { const b = e.target.closest('[data-hs]'); if (b) set(i + parseInt(b.dataset.hs, 10)); });
    set(0);
  });

  /* Reveal fallback */
  setTimeout(() => $$('[data-reveal]').forEach((el) => el.classList.add('is-in')), 2500);

  /* Collection sort */
  const sort = $('#SortBy');
  if (sort) sort.addEventListener('change', () => { const u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); window.location.href = u.toString(); });
})();
